import type {
    CoachAssignmentRole,
    CoachAssignmentSourceType,
    CoachAssignmentStatus,
    CoachEmploymentType,
} from "@flexv-coach/shared";
import {
    ASSIGNMENT_ROLE_LABELS,
    ASSIGNMENT_SOURCE_LABELS,
    ASSIGNMENT_STATUS_LABELS,
    EMPLOYMENT_TYPE_LABELS,
    PAYROLL_ELIGIBILITY_LABELS,
} from "@flexv-coach/shared";
import type { BadgeProps } from "@/components/ui/Badge";

export const statusLabel = (status: CoachAssignmentStatus): string =>
    ASSIGNMENT_STATUS_LABELS[status] ?? status;

export const roleLabel = (role: CoachAssignmentRole): string =>
    ASSIGNMENT_ROLE_LABELS[role] ?? role;

export const sourceLabel = (source: CoachAssignmentSourceType): string =>
    ASSIGNMENT_SOURCE_LABELS[source] ?? source;

export const employmentLabel = (type: CoachEmploymentType): string =>
    EMPLOYMENT_TYPE_LABELS[type] ?? type;

export const payrollLabel = (value: string): string =>
    PAYROLL_ELIGIBILITY_LABELS[value as keyof typeof PAYROLL_ELIGIBILITY_LABELS] ?? value;

type Tone = NonNullable<BadgeProps["tone"]>;

export const statusTone = (status: CoachAssignmentStatus): Tone => {
    switch (status) {
        case "completed":
            return "success";
        case "confirmed":
            return "info";
        case "ongoing":
            return "primary";
        case "cancelled":
        case "no_show":
            return "danger";
        default:
            return "neutral";
    }
};

/** Left border accent per status, used on assignment cards. */
export const statusAccent = (status: CoachAssignmentStatus): string => {
    switch (status) {
        case "completed":
            return "bg-[var(--color-success-text)]";
        case "confirmed":
            return "bg-[var(--color-info-text)]";
        case "ongoing":
            return "bg-[var(--color-primary)]";
        case "cancelled":
        case "no_show":
            return "bg-[var(--color-error-text)]";
        default:
            return "bg-[var(--color-neutral-300)]";
    }
};
